import React from "react";
import { useStore, waLink } from "@/context/StoreContext";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFloat() {
  const { settings } = useStore();
  const wa = settings?.social?.whatsapp;
  if (wa && wa.enabled === false) return null;
  const number = wa?.number || "919000000000";
  return (
    <a
      href={waLink(number, "Hi SHAROA ♡ I need some help.")}
      target="_blank" rel="noreferrer" data-testid="whatsapp-float"
      className="fixed bottom-20 sm:bottom-6 right-4 sm:right-6 z-40 flex items-center gap-2 bg-[#25D366] text-white pl-3 pr-4 py-3 rounded-full shadow-lg hover:scale-105 transition-transform"
    >
      <MessageCircle size={22} />
      <span className="hidden sm:inline text-xs font-semibold uppercase tracking-wide">Chat with us</span>
    </a>
  );
}
